<div class="p-grid reasonCodeBody">
  <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 confirmation-padding">
    <div class="align-center heading">
      <label *ngIf="country != 'de'">{{ 'CONF_SCREEN_TITLE_1' | translate }}</label>
      <!-- <label *ngIf="country == 'de'">{{ 'CONF_SCREEN_TITLE_DE' | translate }}</label> -->
      <label *ngIf="country == 'de' && !dePOA_EORI">{{ 'CONF_SCREEN_TITLE_1' | translate }}</label>
      <label *ngIf="dePOA_EORI">{{ 'CONF_SCREEN_TITLE_DE' | translate }}</label>
    </div>
  </div>
  <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 info-padding">
    <div class="div-info1 align-center" *ngIf="resontwofile">
      <label>{{ 'CONF_SCREEN_PARA_1' | translate }}</label>
    </div>
    <div class="div-info1 align-center" *ngIf="resontwo">
      <label>{{ 'CONF_SCREEN_PARA_ONE_1' | translate }}</label>
    </div>
    <div class="div-info2" *ngIf="resontwo">
      {{ 'TRACK_LINK_P11' | translate }} <a href="{{CUSTOMER_SUPPORT_URL}}" target="_blank" class="linkStyle">{{ 'LINK_HERE' | translate }}</a> {{ 'SUPPORT_LINK_P12' | translate }}
    </div>
    <div class="div-info2" *ngIf="resontwofile">
      {{ 'TRACK_LINK_P11' | translate }} <a href="{{TRACKING_URL}}" target="_blank" class="linkStyle">{{ 'LINK_HERE' | translate }}</a> {{ 'TRACK_LINK_P12' | translate }}
    </div>
    <div class="div-info2" *ngIf="resontwofile">
      {{ 'SUPPORT_LINK_P11' | translate }} <a href="{{CUSTOMER_SUPPORT_URL}}" target="_blank" class="linkStyle">{{ 'LINK_HERE' | translate }}</a> {{ 'SUPPORT_LINK_P12' | translate }}
    </div>
    <div class="div-info2_a">
      {{ 'CONF_SCREEN_LBL_1' | translate }}
    </div>
  </div>
  <!-- <div class="p-col-12 p-lg-12 p-md-12 p-sm-12">
    <div class=" contact-padding">
      <div class="align-center heading contact-border">{{ 'CONF_SCREEN_TITLE_2' | translate }}</div>
      <div *ngIf="CONF_SCR_1" class="p-grid align-center marginBottom">
        <div class="p-col-4 p-md-4 p-lg-4">
          <div>
            <img alt="callsupport.png" src="./assets/img/callsupport.png">
          </div>
          <div class="padding-call-faq">
            <label>{{ 'CONF_SCRN_LBL_2' | translate }}</label>
          </div>
          <div class="call-info">
            <label><strong>{{ 'CONF_SCRN_LBL_3' | translate }}</strong> 0800 0222 333</label>
          </div>
          <div class="call-info">
            <label><strong>{{ 'CONF_SCRN_LBL_4' | translate }}</strong></label><br/>
            <label> +31 (0) 206555260</label>
          </div>
          <div class="call-info">
            <label><strong>{{ 'CONF_SCRN_LBL_SENT_01' | translate }}</strong> {{ 'CONF_SCRN_LBL_SENT_1' | translate }} 08:00 {{ 'CONF_SCREN_LBL_SENT_2' | translate }} 19:00
            </label>
          </div>
        </div>
        <div class="p-col-4 p-md-4 p-lg-4">
          <div class="place-email-icon">
            <img alt="email.png" src="./assets/img/email.png">
          </div>
          <div>
            <label>{{ 'CONF_SCRN_LBL_5' | translate }}</label>
          </div>
          <div class="call-info">
            <label><a class="emailId" href="mailto:netherlands@fedex.com">netherlands@fedex.com</a>
            </label>
          </div>
          <div class="call-info">
            <label>{{ 'CONF_SCRN_LBL_6' | translate }}
            </label>
          </div>
          <div class="button-padding">
            <a class="btn-contact" href="{{WRITE_TO_FEDEX_URL}}" target="_blank">{{ 'CONF_SCRN_LBL_7' | translate }}</a>
          </div>
        </div>
        <div class="p-col-4 p-md-4 p-lg-4">
          <div>
            <img alt="faq.png" src="./assets/img/faq.png">
          </div>
          <div class="padding-call-faq">
            <label>FAQ's</label>
          </div>
          <div class="call-info">
            <label>{{ 'CONF_SCRN_LBL_8' | translate }}
            </label>
          </div>
          <div class="button-padding">
            <a class="btn-contact" href="{{FAQ_URL}}" target="_blank">{{ 'CONF_SCRN_LBL_9' | translate }}</a>
          </div>
        </div>
      </div>
      <div *ngIf="CONF_SCR_2" class="align-center marginBottom">
        <div class="p-col-12 p-md-12 p-lg-12">
          <div>
            <img alt="callsupport.png" src="./assets/img/callsupport.png">
          </div>
          <div class="padding-call-faq">
            <label><strong>Customer Service</strong></label>
          </div>
          <div class="call-info call-info-ph1">
            <label>Mon-Fri: 0800 to 2000</label>
            <label>Sat: 0800 to 1800</label>
            <label>Sun: No Service</label>
            <label>Holidays: 0900 to 1700</label>
          </div>
          <div class="call-info call-info-ph2">
            <label>1800 10 46 33339</label>
            <label>(PLDT, Sun, Smart Subscribers)</label>
          </div>
          <div class="call-info call-info-ph1">
            <label>1800 8 46 33339</label>
            <label>(For Globe Subscribers)</label>
          </div>
          <div class="call-info call-info-ph2">
            <label>045 4993900</label>
            <label>(Other Network Subscribers)</label>
          </div>
          <div class="button-padding">
            <a class="btn-contact" href="{{WRITE_TO_FEDEX_URL}}" target="_blank">WRITE TO FEDEX</a>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
